import { fg } from '@confluence/feature-gating';
import { isCanvasContentType } from './contentTypeConstants.ts';

/**
 This function is used in the Content Types header to determine if the unresolved comments dialog
 should appear for a specific content type (i.e whiteboards/databases and any future content types)
 */
export const useIsCommentsDialogEnabled = (contentType: string | null | undefined): boolean => {
	return (
		(isCanvasContentType(contentType) || contentType === 'database') &&
		// eslint-disable-next-line confluence-feature-gating/no-new-feature-gates -- Existing gate retained during CCP-9677 lint-rule rollout; migration deferred.
		!fg('cc-whiteboards-consolidating-comments')
	);
};
